module.exports = __webpack_public_path__ + "img/sync-alt.4f0b4a24.svg";